export default __webpack_public_path__ + "static/media/Saurbhi_Loader.f4ff2cc9.gif";